import { useNavigate } from '@solidjs/router';
import { BrowserId } from 'Browser/BrowserId';
import { User } from 'Browser/User';
import { SiteBasics } from 'Common/SiteBasics';
import { useSite, useUser } from 'Shared/SiteProvider';
import { Match, onMount, Show, Switch } from 'solid-js';


export function Page(P:{requiresLogin:boolean})
{
	onMount(() => document.body.style.opacity = '1');

	const site = useSite();
	const user = useUser();

//TODO provide decent Missing permissions and Page not found errors... 

//XXX if using ErrorBoundary probably should send errors to server
//XXX perhaps also send browser-side 'page not founds' to server

//XXX ErrorBoundary sometimes hides errors... Also could put in Root.tsx
//		<ErrorBoundary fallback={err => <pre>{JSON.stringify(err)}</pre>}>

	if (P.requiresLogin && user.isUnknown())
		useNavigate()('/login');

	return (
		<Switch>
			<Match when={!P.requiresLogin}>
				{P.children}
			</Match>
			<Match when={!user.isUnknown()}>
				<Show when={havePagePermission(user,site)} fallback='You lack permissions for this site'>
					{P.children}
				</Show>
			</Match>
		</Switch>
	);
}

export function havePagePermission(user:User<BrowserId>,site:SiteBasics<BrowserId>)
{
	if (site.type=='artist')
		return true;
	if (site.type=='venue' && (user.roles.haveVenueRole(site) || user.roles.amGlobalAdmin()))
		return true;
	if (site.type=='admin' && user.roles.amGlobalAdmin())
		return true;
	return false;
}

